var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrap"},[_c('pulse-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }